import { ButtonPlayground } from "../ButtonPlayground";
import { LinkPlayground } from "../LinkPlayground";
import type { PlaygroundComponentEntry } from "../playgroundComponents";

export const actionsEntries: PlaygroundComponentEntry[] = [
    {
        id: "button",
        label: "Button",
        description:
            "Figma-aligned button with type-safe variants, sizes, icon slots, tooltips, loaders, and hotkeys.",
        group: "ready-components",
        render: () => <ButtonPlayground />,
    },
    {
        id: "link",
        label: "Link",
        description:
            "Figma-aligned text link for actions and destinations: a button, an anchor, or a router link through render, with icon slots and icon-only.",
        group: "ready-components",
        render: () => <LinkPlayground />,
    },
];
